import '../main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { reduxForm, Field } from 'redux-form';
import ModalBox from '../../../../shared/modal';
import DatePicker from '../../../../shared/form-elements/date-picker/main';
import Input from '../../../../shared/form-elements/input';
import { formatTime } from '../../../../shared/format';

const Form = props => {
	const { paidAtFormPendingPayout, confirm } = props;
	return (
		<div className="payouts-transaction-form-wrap fraud-form-in-modal">
			<div className="ui-control-bar__item-position payment_selector-container">
				<Field
					name='date'
					component={DatePicker}
					intl={props.intl}
				/>
			</div>
			<div className="payment_selector-container">
				<Field
					name='time'
					component={Input}
					intl={props.intl}
					showLabel={false}
					placeholder={props.intl('00:00')}
					normalize={formatTime}
				/>
			</div>
			<button
				className="ui-btn  ui-btn-cancel apply"
				onClick={() => confirm(
					paidAtFormPendingPayout.selectedPayouts,
					{ partially: paidAtFormPendingPayout.partially }
				)}
			>
				{props.intl('Submit')}
			</button>
		</div>
	);
};

Form.propTypes = {
	intl: PropTypes.func
};

const Main = props =>
	<ModalBox
		title={props.intl('Select payment date')}
		body={Form(props)}
		isOpen={props.isPaymentDatePopupVisible}
		onClose={props.togglePaymentDatePopup}
		className="fraud-form-modal"
	/>;

Main.propTypes = {
	intl: PropTypes.func
};

export default reduxForm({ form: 'paymentAtForm' })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/popups/payment-date/main.js